import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GetAllMaquinasEquipItensDaoModel } from "../../../domain/models/MaquinasEquipItensCadastro";
import { useMaquinasEquipItensCadastroViewModel } from "../../viewModels/Maquinas_equip_itens_cadastro_view_model";
import { GenerateMaquinasEquipItensColumnDefinition } from "./columns";
import { ModalMaquinasEquipItens } from "./components/modal_create";
import { Link as LinkTo } from "react-router";
import { BackButton } from "../../../../../common/components/back_button";

import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";

export const MaquinasEquipItensCadastro = () => {
  const viewModel = useMaquinasEquipItensCadastroViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateMaquinasEquipItensColumnDefinition({
      onActionEditar: viewModel.handleMaquinaEquipItemOpenState,
      onActionDeletar: viewModel.handleMaquinaEquipItemDeleteOpenState,
    });
  }, [
    viewModel.handleMaquinaEquipItemOpenState,
    viewModel.handleMaquinaEquipItemDeleteOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div>
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleMaquinaEquipItemOpenState(null, true)}>
                  Novo Item
                </PrimaryButton>
              </div>
              <div>
                <BackButton onClick={() => viewModel.handleBack()} />
              </div>
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Controle de Patrimônio
          </Link>
          <Link underline="hover" color="inherit" component='span'>
            <LinkTo to="/MaquinasEquip_lista">Máquinas e Equipamentos</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Itens de inspeção de Máquinas e Equipamentos
          </Typography>
        </Breadcrumbs>

        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Itens de Máquinas e Equipamentos</h1>
          <RefreshButton onClick={() => viewModel.handleReload()} />
        </div>

        <Stack spacing={0}>
          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
          />

          <StyledDataGrid
            tableName="maquina_equip_itens_cadastro"
            disableColumnMenu={false}
            showToolbar
            disableRowSelectionOnClick
            getRowId={(row: GetAllMaquinasEquipItensDaoModel) => row.idItemMaquinaEquip ?? ""}
            columns={columnsDefinition}
            loading={viewModel.loading}
            checkboxSelection={false}
            rows={viewModel.maquinaEquipItems}
            rowCount={viewModel.maquinaEquipItems.length}
            pageSizeOptions={[10, 25, 50, 100]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
          />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
          />
        </Stack>
      </div>

      <ModalMaquinasEquipItens
        open={viewModel.maquinaEquipItemModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedMaquinaEquipItem={viewModel.selectedMaquinaEquipItem}
        onClose={() => viewModel.handleMaquinaEquipItemOpenState(null, false)}
        onSubmit={viewModel.handleMaquinaEquipItemSubmit}
      />

      <DeleteDialog
        open={viewModel.maquinaEquipItemDeleteModal}
        onClose={() => viewModel.handleMaquinaEquipItemDeleteOpenState(null, false)}
        title="Você realmente deseja excluir este item?"
        onDelete={viewModel.handleMaquinaEquipItemDeleteSubmit}
      />
    </>
  );
};
